export const whitespaceKeys = ['whiteSpace'];
